export default __webpack_public_path__ + "fab8c0f763aa6e38adf949fe97271fb6.png";